import { inject, Injectable, signal } from '@angular/core';

import { catchError, firstValueFrom, map, of } from 'rxjs';

import { UserApi } from '../api/user.api';
import { IUserInfo } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public userInfo$$ = signal<IUserInfo | null>(null);

  private readonly _userApi = inject(UserApi);

  /** Кто вошёл (CRM-122): `401` — сессии нет, без ошибки; прочие ошибки показывает общий перехватчик. */
  public restore(): Promise<IUserInfo | null> {
    return firstValueFrom(
      this._userApi.getInfoByToken().pipe(
        map((user) => user as IUserInfo | null),
        catchError(() => of(null))
      )
    ).then((user) => {
      this.userInfo$$.set(user);
      return user;
    });
  }

  public clear(): void {
    this.userInfo$$.set(null);
  }
}
